// extracted by mini-css-extract-plugin
module.exports = {"section":"home-tour_section__Ie8p2","image":"home-tour_image__vC4Eo"};